import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { Subscription } from "rxjs";
import { Seasons, SeasonsEntity } from "src/app/equipment/seasons";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { DesignService } from "src/app/design/design.service";
import { DesignFormModel } from "src/app/design/design.model";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";
import { CommonService } from "src/common.service";
import { GlobalConstants } from "src/app/shared/constants/constants";
import { NgForm } from "@angular/forms";
@Component({
  selector: "app-design-form",
  templateUrl: "./design-form.component.html",
  styleUrls: ["./design-form.component.css"],
})
export class DesignFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("designForm") designForm: NgForm;

  private subscription$ = new Subscription();
  showLoader: boolean = false;

  design: any;
  seasons: SeasonsEntity[];
  designEditNewCopyMode: string;
  selectedSeason: string | number = "";
  summarerWinterInfiltrations: String[];
  color = GlobalConstants.ProgressBar.color;
  mode = GlobalConstants.ProgressBar.mode;
  bufferValue = GlobalConstants.ProgressBar.bufferValue;
  progresBarValue: number;
  selectedDesign: any;

  constructor(
    private equipmentService: EquipmentService,
    private designService: DesignService,
    private auth: AuthService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {
    this.summarerWinterInfiltrations =
      GlobalConstants.summarerWinterInfiltrations;
    this.getSeasons();
    this.design = new DesignFormModel();
    this.design.summerinfiltration = "";
    this.design.winterinfiltration = "";
    this.route.queryParams.subscribe((queryParams) => {
      this.designEditNewCopyMode =
        queryParams?.id && queryParams.mode == GlobalConstants.Edit
          ? GlobalConstants.Edit
          : queryParams.mode === GlobalConstants.Copy
          ? GlobalConstants.Copy
          : GlobalConstants.New;
      this.designEditNewCopyMode === GlobalConstants.Edit ||
      this.designEditNewCopyMode === GlobalConstants.Copy
        ? this.getDesingById(queryParams.id)
        : "";
    });
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.subscription$.add(
      this.auth.userProfileSubject$.subscribe((profile) => {
        if (profile) {
          this.setDesignerCompany(
            profile[GlobalConstants.Auth.metadata]?.contractor_id
          );
          this.setDesignerName(
            profile[GlobalConstants.Auth.metadata]?.designer_id,
            profile[GlobalConstants.Auth.metadata]?.contractor_id
          );
        }
      })
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.validateInputs();
    }, 1000);
  }

  /**
   * set Designer Company
   */
  setDesignerCompany(contractorId: number) {
    this.design.customer_id = contractorId;
    this.showLoader = true;
    try {
      this.subscription$.add(
        this.commonService.getContractorList().subscribe(
          (result: any) => {
            this.design.customer_id2 = result.Contractors.find(
              (contractor) => contractor.id === contractorId
            ).name;
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(
              `${GlobalConstants.APIError.ErrorGettingDesignerCompany}`,
              "",
              {
                duration: 2000,
              }
            );
          }
        )
      );
    } catch (error) {
      this.showLoader = false;
      this.snackBar.open(
        `${GlobalConstants.APIError.ErrorDisplayingDesingerCompany}`,
        "",
        {
          duration: 2000,
        }
      );
    }
  }

  /**
   * set Designer Name
   */
  setDesignerName(designerId: number, contractorId: number) {
    this.design.contact_id = designerId;
    this.showLoader = true;
    try {
      this.subscription$.add(
        this.commonService.getDesignersList(contractorId).subscribe(
          (result: any) => {
            this.design.contact_id2 = result.Designers.find(
              (designer) => designer.id === designerId
            ).name;
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(
              `${GlobalConstants.APIError.ErrorGettingDesignerName}`,
              "",
              {
                duration: 2000,
              }
            );
          }
        )
      );
    } catch (error) {
      this.showLoader = false;
      this.snackBar.open(
        `${GlobalConstants.APIError.ErrorDisplayingDesingerName}`,
        "",
        {
          duration: 2000,
        }
      );
    }
  }

  /**
   * Get Design Details By Id
   */
  getDesingById(desingId: String | number) {
    this.selectedDesign = desingId;
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getSingleDesign(desingId).subscribe(
        (result: any) => {
          if (result?.Designs) {
            this.design = result.Designs;
            this.design.customer_id2 = result.Designs.companyname;
            this.design.contact_id2 = result.Designs.contact_id;
          }
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(
            `${GlobalConstants.APIError.ErrorGettingDesingDetails}`,
            "",
            {
              duration: 2000,
            }
          );
        }
      )
    );
  }

  /**
   * Get Seasons
   */
  getSeasons() {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getSeasons().subscribe(
        (result: Seasons) => {
          if (result?.Seasons?.length) {
            this.seasons = result.Seasons;
            this.showLoader = false;
          } else {
            this.showLoader = false;
          }
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(
            `${GlobalConstants.APIError.ErrorGettingSeasons}`,
            "",
            {
              duration: 2000,
            }
          );
        }
      )
    );
  }


  cancel(): void {
    this.router.navigate(["/design"]);
  }

  /**
   * Save, Update or Copy Design
   */
  save(){
    this.design.designcomplete = true;
    this.design.completesystems = true;
    this.showLoader = true;
    let operation =
      this.designEditNewCopyMode === GlobalConstants.Edit
        ? "updateExisitngDesign"
        : "addNewDesign";
    this.subscription$.add(
      this.designService[operation](this.design).subscribe(
        (res) => {
          console.log(res);
          this.showLoader = false;
          if (this.designEditNewCopyMode === "Copy") {
            this.router.navigate(["/copySystem"], {
              queryParams: { id: this.selectedDesign, newId: res.Id },
            });
          }else{
            this.router.navigate(["/design"]);
          }
          this.snackBar.open(
            `${
              this.designEditNewCopyMode === GlobalConstants.Edit
                ? "Design Updated Sucessfully"
                : this.designEditNewCopyMode === GlobalConstants.Copy
                ? "Design Copied Sucessfully"
                : "Design Created Sucessfully"
            }`,
            "",
            {
              duration: 2000,
            }
          );
        },
        (error) => {
          this.snackBar.open(
            `${
              this.designEditNewCopyMode === GlobalConstants.Edit
                ? "Error in Updating Design"
                : this.designEditNewCopyMode === GlobalConstants.Copy
                ? "Error in Copying Design "
                : "Error in Creating Design"
            } `,
            "",
            {
              duration: 2000,
            }
          );
        }
      )
    );
  }

  /**
   * Change Season
   */
  changeSeason() {
    if (this.selectedSeason != "") {
      let season = this.seasons.find(
        (season) => season.temp_id == this.selectedSeason
      );
      this.design.outdoor1_ = season?.pctcooling_1;
      this.design.outdoor99_ = season?.pctheating_1;
      this.design.outdoortemplocation = season.state + "  " + season.county;
    }
  }

  /**
   * validate input fields and show progress bar
   */

  validateInputs() {
    let inputCount = 0;
    Object.keys(this.designForm.controls).map((field) => {
      if (this.designForm.controls[field].value) inputCount++;
    });

    this.progresBarValue =
      (inputCount / Object.keys(this.designForm.controls).length) * 100;
  }
  /**
   * unsubscribe the subscriptions
   */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
